/**
 * Custom Global Data Object
 */
const GlobalData = {};
export default GlobalData;
